// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-progressLine{
    font-family: 'Inter';
font-style: normal;
font-weight: 600 !important;
font-size: 18px;
line-height: 19px;

color: #000000;
text-align: left;
}
.header-progressLine-inOut{
    font-family: 'Inter' !important;
font-style: normal !important;
font-weight: 600 !important;
font-size: 16px !important;
line-height: 19px !important;
width: 24% !important;
color: #000000;
text-align: left;
}
.box-progressLine{
    width: 100%;
height: 180px;
background: #FFFFFF;
box-shadow: 0px;
border-radius: 10px;
padding: 10px;
}
.smallText-progressLine{
font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 15px;
/* identical to box height */
color: #808080;
width: 25%;
}
.smallText-progressLine-out{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    /* identical to box height */
    color: #808080;
    width: 45%;
    }

.card-background{
    width: 100%;
height: 250px;
/* left: 1007px;
top: 799px;
margin: 20px; */
background: #F4F8F9;
border-radius: 5px;
border-bottom: 3px solid #0596FF;
padding: 10px;
margin-top: 20px
}
.test-data-review{
    font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 18px;
/* line-height: 12px; */
/* identical to box height */
width: 50%;
text-transform: capitalize;
/* padding: 10px; */
color: #001A11;

}
.test-data-review-dashboard{
    font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 18px !important;
line-height: 12px;
/* identical to box height */

text-transform: capitalize;
padding: 10px;
color: #001A11;

}
.progress-circle-component{
/* width: 32%; */
width: 97%;
/* height: 340px; */
height: 200px;
background: #F4F8F9;
padding-top: 6px;
border-bottom: 3px solid #009966;
border-radius: 5px;
justify-content: center;
align-items: center;
padding-left: 10px;
/* padding-right: 3px; */
/* margin-left: 12px; */
}
.progress-circle-component-mf{
    /* width: 32%; */
    width: 97%;
/* height: 340px; */
height: 205px;
background: #F4F8F9;
padding-top: 6px;
border-bottom: 3px solid #0596FF;
/* border-bottom: 3px solid #D65442; */
border-radius: 5px;
justify-content: center;
align-items: center;
padding-left: 10px;
/* padding-right: 5px; */
margin-top: 20px;
}
.dashboard-header{
    width: 106px;
height: 24px;
font-family: 'Inter';
font-style: normal;
font-weight: 600;
font-size: 20px;
line-height: 24px;
text-transform: capitalize;

color: #001A11;


/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
}
.progress-circle-component-nfr{
width: 45%;
height: 340px;
/* background: #F4F8F9; */
border-radius: 5px;
/* padding-top: 3px; */
/* border-bottom: 3px solid #0596FF; */
/* margin-left: 14px; */
}
.setup-status-component{
width: 100%;
/* height: 390px; */
/* margin-top: 20px; */
background: #F4F8F9;
border-radius: 5px;
}
.chart-background{
    display: flex;
    position: relative;
flex-direction: column;
align-items: flex-start;
padding: 20px;
/* gap: 19px; */
/* margin: 13px; */
/* margin-top: 5px; */
border-bottom: 3px solid #165DFF;
width: 97%;
height: 380px;

background: #F4F8F9;
border-radius: 5px;
margin-top: 20px;
}
.chart-header-text{
    width: 184px;
height: 22px;

font-family: 'Inter';
font-style: normal;
font-weight: 600 !important;
font-size: 18px;
line-height: 22px;
/* identical to box height */

text-transform: capitalize;

color: #001A11;


/* Inside auto layout */

flex: none;
order: 0;
flex-grow: 0;
}
.progress-circle{
    
width: 100%;
height: 130px;

background: #FFFFFF;
box-shadow: 0px ;
border-radius: 10px;
}
.dropdown-chart{
    border-color: #FFFFFF !important;
}

.createDateRangePicker
  .ant-picker-cell-in-view.ant-picker-cell-range-start
  .ant-picker-cell-inner {
  background-color: #27c456 !important;
}

.createDateRangePicker
  .ant-picker-cell-in-view.ant-picker-cell-range-end
  .ant-picker-cell-inner {
  background-color: #27c456 !important;
}

.createDateRangePicker
  .ant-picker-cell-in-view.ant-picker-cell-today
  .ant-picker-cell-inner::before {
  border-color: #1f9643e5 !important;
}

.createDateRangePicker
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
.createDateRangePicker
  .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
.createDateRangePicker
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,
.createDateRangePicker
  .ant-picker-time-panel-column
  > li.ant-picker-time-panel-cell-selected
  .ant-picker-time-panel-cell-inner {
  background: #e6ffe8 !important;
}

.createDateRangePicker .ant-btn-primary {
  background-color: #1f9643e5 !important;
  border-color: #1f9643e5 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/dashBoard.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB,kBAAkB;AAClB,2BAA2B;AAC3B,eAAe;AACf,iBAAiB;;AAEjB,cAAc;AACd,gBAAgB;AAChB;AACA;IACI,+BAA+B;AACnC,6BAA6B;AAC7B,2BAA2B;AAC3B,0BAA0B;AAC1B,4BAA4B;AAC5B,qBAAqB;AACrB,cAAc;AACd,gBAAgB;AAChB;AACA;IACI,WAAW;AACf,aAAa;AACb,mBAAmB;AACnB,eAAe;AACf,mBAAmB;AACnB,aAAa;AACb;AACA;AACA,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,4BAA4B;AAC5B,cAAc;AACd,UAAU;AACV;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;IACd,UAAU;IACV;;AAEJ;IACI,WAAW;AACf,aAAa;AACb;;eAEe;AACf,mBAAmB;AACnB,kBAAkB;AAClB,gCAAgC;AAChC,aAAa;AACb;AACA;AACA;IACI,oBAAoB;AACxB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,uBAAuB;AACvB,4BAA4B;AAC5B,UAAU;AACV,0BAA0B;AAC1B,mBAAmB;AACnB,cAAc;;AAEd;AACA;IACI,oBAAoB;AACxB,kBAAkB;AAClB,gBAAgB;AAChB,0BAA0B;AAC1B,iBAAiB;AACjB,4BAA4B;;AAE5B,0BAA0B;AAC1B,aAAa;AACb,cAAc;;AAEd;AACA;AACA,gBAAgB;AAChB,UAAU;AACV,mBAAmB;AACnB,aAAa;AACb,mBAAmB;AACnB,gBAAgB;AAChB,gCAAgC;AAChC,kBAAkB;AAClB,uBAAuB;AACvB,mBAAmB;AACnB,kBAAkB;AAClB,wBAAwB;AACxB,uBAAuB;AACvB;AACA;IACI,gBAAgB;IAChB,UAAU;AACd,mBAAmB;AACnB,aAAa;AACb,mBAAmB;AACnB,gBAAgB;AAChB,gCAAgC;AAChC,sCAAsC;AACtC,kBAAkB;AAClB,uBAAuB;AACvB,mBAAmB;AACnB,kBAAkB;AAClB,wBAAwB;AACxB,gBAAgB;AAChB;AACA;IACI,YAAY;AAChB,YAAY;AACZ,oBAAoB;AACpB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,0BAA0B;;AAE1B,cAAc;;;AAGd,uBAAuB;;AAEvB,UAAU;AACV,QAAQ;AACR,YAAY;AACZ;AACA;AACA,UAAU;AACV,aAAa;AACb,yBAAyB;AACzB,kBAAkB;AAClB,sBAAsB;AACtB,sCAAsC;AACtC,uBAAuB;AACvB;AACA;AACA,WAAW;AACX,mBAAmB;AACnB,sBAAsB;AACtB,mBAAmB;AACnB,kBAAkB;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB,sBAAsB;AACtB,uBAAuB;AACvB,aAAa;AACb,eAAe;AACf,kBAAkB;AAClB,qBAAqB;AACrB,gCAAgC;AAChC,UAAU;AACV,aAAa;;AAEb,mBAAmB;AACnB,kBAAkB;AAClB,gBAAgB;AAChB;AACA;IACI,YAAY;AAChB,YAAY;;AAEZ,oBAAoB;AACpB,kBAAkB;AAClB,2BAA2B;AAC3B,eAAe;AACf,iBAAiB;AACjB,4BAA4B;;AAE5B,0BAA0B;;AAE1B,cAAc;;;AAGd,uBAAuB;;AAEvB,UAAU;AACV,QAAQ;AACR,YAAY;AACZ;AACA;;AAEA,WAAW;AACX,aAAa;;AAEb,mBAAmB;AACnB,gBAAgB;AAChB,mBAAmB;AACnB;AACA;IACI,gCAAgC;AACpC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;;;;;;;;EAUE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC","sourcesContent":[".header-progressLine{\n    font-family: 'Inter';\nfont-style: normal;\nfont-weight: 600 !important;\nfont-size: 18px;\nline-height: 19px;\n\ncolor: #000000;\ntext-align: left;\n}\n.header-progressLine-inOut{\n    font-family: 'Inter' !important;\nfont-style: normal !important;\nfont-weight: 600 !important;\nfont-size: 16px !important;\nline-height: 19px !important;\nwidth: 24% !important;\ncolor: #000000;\ntext-align: left;\n}\n.box-progressLine{\n    width: 100%;\nheight: 180px;\nbackground: #FFFFFF;\nbox-shadow: 0px;\nborder-radius: 10px;\npadding: 10px;\n}\n.smallText-progressLine{\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 12px;\nline-height: 15px;\n/* identical to box height */\ncolor: #808080;\nwidth: 25%;\n}\n.smallText-progressLine-out{\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 15px;\n    /* identical to box height */\n    color: #808080;\n    width: 45%;\n    }\n\n.card-background{\n    width: 100%;\nheight: 250px;\n/* left: 1007px;\ntop: 799px;\nmargin: 20px; */\nbackground: #F4F8F9;\nborder-radius: 5px;\nborder-bottom: 3px solid #0596FF;\npadding: 10px;\nmargin-top: 20px\n}\n.test-data-review{\n    font-family: 'Inter';\nfont-style: normal;\nfont-weight: 600;\nfont-size: 18px;\n/* line-height: 12px; */\n/* identical to box height */\nwidth: 50%;\ntext-transform: capitalize;\n/* padding: 10px; */\ncolor: #001A11;\n\n}\n.test-data-review-dashboard{\n    font-family: 'Inter';\nfont-style: normal;\nfont-weight: 600;\nfont-size: 18px !important;\nline-height: 12px;\n/* identical to box height */\n\ntext-transform: capitalize;\npadding: 10px;\ncolor: #001A11;\n\n}\n.progress-circle-component{\n/* width: 32%; */\nwidth: 97%;\n/* height: 340px; */\nheight: 200px;\nbackground: #F4F8F9;\npadding-top: 6px;\nborder-bottom: 3px solid #009966;\nborder-radius: 5px;\njustify-content: center;\nalign-items: center;\npadding-left: 10px;\n/* padding-right: 3px; */\n/* margin-left: 12px; */\n}\n.progress-circle-component-mf{\n    /* width: 32%; */\n    width: 97%;\n/* height: 340px; */\nheight: 205px;\nbackground: #F4F8F9;\npadding-top: 6px;\nborder-bottom: 3px solid #0596FF;\n/* border-bottom: 3px solid #D65442; */\nborder-radius: 5px;\njustify-content: center;\nalign-items: center;\npadding-left: 10px;\n/* padding-right: 5px; */\nmargin-top: 20px;\n}\n.dashboard-header{\n    width: 106px;\nheight: 24px;\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 600;\nfont-size: 20px;\nline-height: 24px;\ntext-transform: capitalize;\n\ncolor: #001A11;\n\n\n/* Inside auto layout */\n\nflex: none;\norder: 0;\nflex-grow: 0;\n}\n.progress-circle-component-nfr{\nwidth: 45%;\nheight: 340px;\n/* background: #F4F8F9; */\nborder-radius: 5px;\n/* padding-top: 3px; */\n/* border-bottom: 3px solid #0596FF; */\n/* margin-left: 14px; */\n}\n.setup-status-component{\nwidth: 100%;\n/* height: 390px; */\n/* margin-top: 20px; */\nbackground: #F4F8F9;\nborder-radius: 5px;\n}\n.chart-background{\n    display: flex;\n    position: relative;\nflex-direction: column;\nalign-items: flex-start;\npadding: 20px;\n/* gap: 19px; */\n/* margin: 13px; */\n/* margin-top: 5px; */\nborder-bottom: 3px solid #165DFF;\nwidth: 97%;\nheight: 380px;\n\nbackground: #F4F8F9;\nborder-radius: 5px;\nmargin-top: 20px;\n}\n.chart-header-text{\n    width: 184px;\nheight: 22px;\n\nfont-family: 'Inter';\nfont-style: normal;\nfont-weight: 600 !important;\nfont-size: 18px;\nline-height: 22px;\n/* identical to box height */\n\ntext-transform: capitalize;\n\ncolor: #001A11;\n\n\n/* Inside auto layout */\n\nflex: none;\norder: 0;\nflex-grow: 0;\n}\n.progress-circle{\n    \nwidth: 100%;\nheight: 130px;\n\nbackground: #FFFFFF;\nbox-shadow: 0px ;\nborder-radius: 10px;\n}\n.dropdown-chart{\n    border-color: #FFFFFF !important;\n}\n\n.createDateRangePicker\n  .ant-picker-cell-in-view.ant-picker-cell-range-start\n  .ant-picker-cell-inner {\n  background-color: #27c456 !important;\n}\n\n.createDateRangePicker\n  .ant-picker-cell-in-view.ant-picker-cell-range-end\n  .ant-picker-cell-inner {\n  background-color: #27c456 !important;\n}\n\n.createDateRangePicker\n  .ant-picker-cell-in-view.ant-picker-cell-today\n  .ant-picker-cell-inner::before {\n  border-color: #1f9643e5 !important;\n}\n\n.createDateRangePicker\n  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,\n.createDateRangePicker\n  .ant-picker-cell-in-view.ant-picker-cell-in-range::before,\n.createDateRangePicker\n  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before,\n.createDateRangePicker\n  .ant-picker-time-panel-column\n  > li.ant-picker-time-panel-cell-selected\n  .ant-picker-time-panel-cell-inner {\n  background: #e6ffe8 !important;\n}\n\n.createDateRangePicker .ant-btn-primary {\n  background-color: #1f9643e5 !important;\n  border-color: #1f9643e5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
